<div class="flex-column flex-fill">
  <div class="row pb-1 pt-1">
    <div class="col-md-12">
      <div class="float-end custom-split-button">
        <button type="button" kendoButton themeColor="base" [disabled]="loading || !editMode" (click)="onCancel($event)"
          [buttonLoading]="loading" [svgIcon]="icons.cancel" class="me-1">
          Cancel
        </button>
        <button type="button" kendoButton themeColor="primary" [disabled]="loading || !editMode" (click)="onSave($event)"
          [buttonLoading]="loading" [svgIcon]="icons.save" class="me-1">
          Save
        </button>
      </div>
    </div>
  </div>
  <ag-grid-angular style="height: 100%" class="ag-theme-balham" [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>